'use client';

import { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import DeliveryTemplate from '@/modules/Checkout/DeliveryTemplate';
import { OPEN_FULFILLMENT_PANEL } from '@/helpers/fulfillmentGuard';
import DeliveryBarStyle, { StickyDeliveryGlobalStyle } from './style';
import { useStickyDeliveryPanel } from './useStickyDeliveryPanel';

const StickyDeliveryDropdown = ({ globalData, initialTab, redirectAfterConfirm = false, className = '', trigger }) => {
	const { isOpen, rootRef, closePanel, closePanelFromBackdrop, openPanel, togglePanel } = useStickyDeliveryPanel();
	const [mounted, setMounted] = useState(false);
	const [eventRedirect, setEventRedirect] = useState(null);
	const isShopBar = (className || '').includes('is-shop-fulfillment-bar');

	const handleClosePanel = useCallback(() => {
		setEventRedirect(null);
		closePanel();
	}, [closePanel]);

	const handleCloseFromBackdrop = useCallback(
		(event) => {
			setEventRedirect(null);
			closePanelFromBackdrop(event);
		},
		[closePanelFromBackdrop]
	);

	const effectiveRedirect = eventRedirect ?? redirectAfterConfirm;

	useEffect(() => {
		setMounted(true);
	}, []);

	useEffect(() => {
		const handleOpenPanel = (event) => {
			if (event.detail && 'redirectAfterConfirm' in event.detail) {
				setEventRedirect(event.detail.redirectAfterConfirm || false);
			}
			requestAnimationFrame(() => openPanel());
		};

		window.addEventListener(OPEN_FULFILLMENT_PANEL, handleOpenPanel);
		return () => window.removeEventListener(OPEN_FULFILLMENT_PANEL, handleOpenPanel);
	}, [openPanel]);

	const panel = isOpen ? (
		<div className='sticky-delivery-panel'>
			<DeliveryTemplate
				variant='dropdown'
				globalData={globalData}
				initialTab={initialTab}
				redirectAfterConfirm={effectiveRedirect}
				onClose={handleClosePanel}
			/>
		</div>
	) : null;

	const backdrop =
		mounted && isOpen
			? createPortal(
					<div
						className='sticky-delivery-backdrop'
						aria-hidden
						onClick={handleCloseFromBackdrop}
					/>,
					document.body
				)
			: null;

	return (
		<>
			<StickyDeliveryGlobalStyle />
			<DeliveryBarStyle className={className}>
				<div
					className='sticky-delivery-root'
					ref={rootRef}
				>
					{trigger({ isOpen, togglePanel, closePanel: handleClosePanel })}
					{/* Shop bar: panel is portaled to body to escape header overflow:clip */}
					{!isShopBar && panel}
				</div>
			</DeliveryBarStyle>
			{/* Wrapped in DeliveryBarStyle so styled-components styles apply correctly */}
			{isShopBar && mounted && panel && createPortal(<DeliveryBarStyle className={`${className} shop-delivery-panel-host`}>{panel}</DeliveryBarStyle>, document.body)}
			{backdrop}
		</>
	);
};

export default StickyDeliveryDropdown;
